import { email as addressEmail } from '@sideway/address';

/**
 * Single source of truth for email validity across the app.
 *
 * Uses @sideway/address (Joi's validator) rather than zod's built-in
 * `z.email()`: it validates the TLD against the real registry and accepts
 * non-ASCII local parts, which matters for our es/fr locales. Sign-up and
 * checkout must agree — see SQR-15156.
 *
 * Trims defensively so a pasted address with surrounding whitespace is
 * judged on its content. Callers should still `.trim()` in their schema to
 * normalise the value that gets stored.
 */
export function isValidEmail(email: string | null | undefined): boolean {
  if (!email) return false;

  return addressEmail.isValid(email.trim());
}
